import { watchEffect } from "vue";

/**
 * Drives document.title from a reactive source.
 * Pass a getter that returns the desired title; clears to "operate-playground"
 * when the getter returns null.
 */
export function useTabTitle(getter: () => string | null) {
  watchEffect(() => {
    const t = getter();
    document.title = t ?? "operate-playground";
  });
}
